module.exports = __webpack_public_path__ + "static/time-clocks-app-for-restaurants-8dfcc9663db7e58e3ac9d1ba2e448ecb.png";